import Vue from 'vue';

const vue = new Vue();

export type EventBus = Pick<Vue, '$on' | '$off' | '$emit'>;

export const EventBus: EventBus = {
  $on: vue.$on.bind(vue),
  $off: vue.$off.bind(vue),
  $emit: vue.$emit.bind(vue)
};

export interface UpdateDatePickerPayload {
  type: 'days' | 'months'
  amount: -1 | 1
}

export const EventBusEvents = {
  siteFile: 'siteFile',
  hasFile: 'hasFile',
  setLoadValues: 'setLoadValues', // TODO seems to be dead
  loadScenario: 'loadScenario',
  deleteScenario: 'deleteScenario',
  editProject: 'editProject',
  duplicateScenario: 'duplicateScenario',
  controlAllFields: 'controlAllFields',
  setPath: 'setPath',
  refreshLocal: 'refreshLocal',
  playVideo: 'playVideo',
  killVideo: 'killVideo',
  diagramChartLoaded: 'diagramChartLoaded', // TODO seems to be dead
  energyChartLoaded: 'energyChartLoaded', // TODO seems to be dead
  saveLatestOpenedProject: 'saveLatestOpenedProject', // TODO seems to be dead
  mustControlMyself: 'mustControlMyself',
  updateDatePicker: 'updateDatePicker',
  getControlFieldEvent: (fieldName: string): string => {
    return `controlField_${fieldName}`;
  },
  getAddErrorToFieldEvent: (fieldName: string): string => {
    return `addErrorToField_${fieldName}`;
  }
};
